import { render, staticRenderFns } from "./addconsumables.vue?vue&type=template&id=3871c5c6&scoped=true&"
import script from "./addconsumables.vue?vue&type=script&lang=js&"
export * from "./addconsumables.vue?vue&type=script&lang=js&"
import style0 from "./addconsumables.vue?vue&type=style&index=0&id=3871c5c6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871c5c6",
  null
  
)

export default component.exports